import React from "react";
import List from "../List";
import ShopsIntro from "../ShopsIntro";
import ShopsFeeTermsAndConditionsPopup from "../popups/ShopsFeeTermsAndConditionsPopup";
import { useIdentity, useShopsTermPopup } from "../../../hooks";
import LoadingGear from "./LoadingGear";

interface ShopsPageProps {
  charges: {
    acceptShopCharges: boolean;
    isShopsTermsAndConditionsAccepted: boolean;
    loading: boolean;
  };
}

const ShopsPage: React.FC<ShopsPageProps> = ({ charges }) => {
  const identity = useIdentity();
  const { acceptShopCharges, isShopsTermsAndConditionsAccepted, loading } =
    charges;
  const { showPopup, dismiss } = useShopsTermPopup({
    acceptShopCharges,
    isShopsTermsAndConditionsAccepted,
    ready: !loading,
  });
  return (
    <div className="main-content">
      {loading ? (
        <LoadingGear />
      ) : acceptShopCharges ? (
        <List />
      ) : (
        <ShopsIntro />
      )}
      {showPopup ? (
        <ShopsFeeTermsAndConditionsPopup
          company_id={identity.company_id}
          new_shop_user={false}
          disabled={!identity.capabilities.includes("ACCEPT-SHOP-TERMS")}
          on_close={dismiss}
        />
      ) : null}
    </div>
  );
};
export default ShopsPage;
